(function(){
  const root=document.querySelector('[data-rx-reveal]');
  if(!root)return;

  const cards=[...root.querySelectorAll('[data-rx-card]')];
  const steps=[...root.querySelectorAll('[data-rx-step]')];
  const launch=document.querySelector('[data-rx-reveal-launch]');
  const count=root.querySelector('[data-rx-count]');
  const continueButton=root.querySelector('[data-rx-continue]');
  const closeButton=root.querySelector('[data-rx-reveal-close]');
  const confettiLayer=root.querySelector('[data-rx-confetti]');
  const logo='https://rxnicotine.com/cdn/shop/files/LOGO-with-Slogan.svg?v=1779462903&width=520';
  let revealed=0;
  let lastFocus=null;
  let closeTimer=null;

  const blackCard='<span class="rxq-mini-ai-card" aria-hidden="true"><img src="'+logo+'" alt=""><span class="rxq-mini-ai-card-title">AI PERSONAL<br>SWITCH COACH</span><span class="rxq-mini-ai-card-meta"><span>NFC SMART TAP</span><span>TAP TO TALK</span></span></span>';
  const prizes=[
    {title:'Free Shipping',detail:'Included',icon:'<i class="fa-solid fa-truck-fast" aria-hidden="true"></i>'},
    {title:'AI Black Card',detail:'Tap to Talk Access',icon:blackCard},
    {title:"Year’s Supply Entry",detail:'Chance to Win',icon:'<i class="fa-solid fa-gift" aria-hidden="true"></i>'},
    {title:'Subscriber Discount',detail:'Best Available Pricing',icon:'<i class="fa-solid fa-tag" aria-hidden="true"></i>'}
  ];

  function showStep(name){
    steps.forEach(step=>step.classList.toggle('is-active',step.dataset.rxStep===name));
  }

  function confetti(){
    confettiLayer.innerHTML='';
    const colors=['#d79a24','#214e8b','#10100f','#ffffff','#f4bd43'];
    for(let i=0;i<70;i++){
      const piece=document.createElement('i');
      piece.style.setProperty('--x',(Math.random()*100)+'%');
      piece.style.setProperty('--c',colors[i%colors.length]);
      piece.style.setProperty('--r',(Math.random()*180)+'deg');
      piece.style.setProperty('--d',(1.7+Math.random()*1.6)+'s');
      piece.style.setProperty('--delay',(Math.random()*.35)+'s');
      piece.style.setProperty('--drift',(-90+Math.random()*180)+'px');
      confettiLayer.appendChild(piece);
    }
    setTimeout(()=>{confettiLayer.innerHTML='';},3600);
  }

  function revealCard(card){
    if(card.classList.contains('is-flipped')||revealed>=4)return;
    const prize=prizes[revealed];
    card.querySelector('.rx-card__front').innerHTML='<span class="rx-card__icon">'+prize.icon+'</span><strong>'+prize.title+'</strong><small>'+prize.detail+'</small>';
    card.classList.add('is-flipped');
    card.setAttribute('aria-label','Card flipped: '+prize.title);
    card.disabled=true;
    revealed++;
    count.textContent=revealed+'/4';
    const remaining=4-revealed;
    continueButton.textContent=remaining?'Flip '+remaining+' More Card'+(remaining===1?'':'s'):'🎁 Continue';
    if(!remaining){
      continueButton.disabled=false;
      confetti();
    }
  }

  function showCloseLater(){
    closeButton.classList.remove('is-visible');
    clearTimeout(closeTimer);
    closeTimer=setTimeout(()=>closeButton.classList.add('is-visible'),2400);
  }

  function open(){
    lastFocus=document.activeElement;
    root.setAttribute('aria-hidden','false');
    if(launch)launch.hidden=true;
    document.body.classList.add('rx-reveal-open');
    showCloseLater();
  }

  function close(){
    root.setAttribute('aria-hidden','true');
    document.body.classList.remove('rx-reveal-open');
    clearTimeout(closeTimer);
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }

  function reset(){
    revealed=0;
    cards.forEach((card,index)=>{
      card.classList.remove('is-flipped');
      card.disabled=false;
      card.setAttribute('aria-label','Card '+(index+1));
      card.querySelector('.rx-card__front').innerHTML='';
    });
    count.textContent='0/4';
    continueButton.textContent='Flip 4 More Cards';
    continueButton.disabled=true;
    confettiLayer.innerHTML='';
    showStep('cards');
  }

  function validEmail(value){
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function returnToHero(){
    close();
    requestAnimationFrame(()=>window.scrollTo({top:0,left:0,behavior:'auto'}));
  }

  cards.forEach(card=>card.addEventListener('click',()=>revealCard(card)));
  continueButton.addEventListener('click',()=>{if(revealed===4)showStep('reason');});
  root.querySelectorAll('[data-rx-reason]').forEach(button=>button.addEventListener('click',()=>showStep('email')));

  root.querySelector('[data-rx-email-form]').addEventListener('submit',event=>{
    event.preventDefault();
    const input=root.querySelector('#rx-reveal-email');
    const error=root.querySelector('[data-rx-email-error]');
    if(!validEmail(input.value.trim())){
      error.textContent='Enter a valid email address.';
      input.focus();
      return;
    }
    error.textContent='';
    showStep('phone');
    setTimeout(()=>root.querySelector('#rx-reveal-phone').focus(),80);
  });

  root.querySelector('[data-rx-phone-form]').addEventListener('submit',event=>{
    event.preventDefault();
    const input=root.querySelector('#rx-reveal-phone');
    const error=root.querySelector('[data-rx-phone-error]');
    if(input.value.replace(/\D/g,'').length<10){
      error.textContent='Enter a valid mobile number.';
      input.focus();
      return;
    }
    error.textContent='';
    returnToHero();
  });

  closeButton.addEventListener('click',close);
  if(launch)launch.addEventListener('click',()=>{reset();open();});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&root.getAttribute('aria-hidden')==='false')close();});
  window.RXReveal={open,close,reset};
})();
